<div class="notification">
    <Snackbar bind:this={self} class="snackbar-{type}">
        <Label>{message}</Label>
        <Actions>
            <IconButton class="material-icons" title="Dismiss">close</IconButton>
        </Actions>
    </Snackbar>
</div>

<script>
    import Snackbar, {Actions, Label} from '@smui/snackbar';
    import Kitchen from '@smui/snackbar/kitchen/index';
    import Button from '@smui/button';
    import IconButton from '@smui/icon-button';
    import Textfield from '@smui/textfield';

    export let type;
    export let message;
    export let show = false;

    let self;

    $: if (self && message) {
        self.open();
    }
</script>

<style>
    :global(.notification .snackbar-success .mdc-snackbar__surface) {
        background: green;
        color: white;
        font-weight: bold;
    }

    :global(.notification .snackbar-error .mdc-snackbar__surface) {
        background: #C00;
        color: white;
        font-weight: bold;
    }
</style>